module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Laufenburg_AG-f494068d0b84ebc57dc7b2c42a6af27f.svg";